angular
    .module('festzelt-os.billing')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.billing', {
            abstract: true,
            url: '/billing/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'Invoice Templates',
                showBackBtn: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/billing-routes.js